import React from 'react';
import { Card, Row, Col } from 'antd';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import LoggedLayout from '../../components/Layouts/LoggedLayout';
import GuestLayout from '../../components/Layouts/GuestLayout';

const SendToEmailWrapper = ({ consumer }) => {
  const { email } = consumer;
  const style = {
    textAlign: 'center'
  };
  return (
    <Row gutter={[16, 16]} justify="space-between" align="middle">
      <Col span={24}>
        <Card>
          <Row>
            <Col span={24} lg={6}>
              <Card bordered={false}>
                <img height="250" src="/public/images/bird.png" alt="" />
              </Card>
            </Col>
            <Col span={24} lg={18}>
              <Card bordered={false} style={style}>
                The link to view the floor plan that best matches your requirements has been sent to
                the email address {email ? `(${email})` : null} provided.
              </Card>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
};

const SendToEmail = props => {
  return (
    <>
      {props.loggedIn ? (
        <LoggedLayout>
          <SendToEmailWrapper {...props} />
        </LoggedLayout>
      ) : (
        <GuestLayout>
          <SendToEmailWrapper {...props} />
        </GuestLayout>
      )}
    </>
  );
};

const mapStateToProps = state => {
  return {
    loggedIn: state.auth.loggedIn,
    consumer: state.consumer
  };
};

SendToEmail.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
  consumer: PropTypes.object
};

const connectedSendToEmailPage = connect(mapStateToProps)(SendToEmail);

export default connectedSendToEmailPage;
